/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon16Light = forwardRef('WarningCircleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.25 10.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" }),
        React.createElement("path", { d: "M8 4.5a.5.5 0 0 0-1 0v3.4a.5.5 0 0 0 1 0V4.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 7.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM7.5 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
